import { action, payload } from 'ts-action'
import { IError, IPayload } from 'models/Global'
import { IUser } from 'models/User'

export const ManagersFetching = action('ManagersFetching', payload<boolean>())
export const GetManagers = action('GetManagers', payload<IPayload<IUser[]>>())
export const GetManagersError = action('GetManagersError', payload<IError>())
export const DeleteManager = action('DeleteManager', payload<number>())
